module.exports = __webpack_public_path__ + "img/travel_01.b32bc574.png";